import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { IEnrollment } from 'src/app/core/models/enrollments.model';
import { EnrollmentsService } from '../enrollments-service/enrollments.service';
import {
  MixpanelEventType,
  MixpanelService,
} from '../mixpanel-service/mixpanel.service';
import { Messages } from '../notification-service/notification-messages';
import { NotificationService } from '../notification-service/notification.service';

@Injectable({
  providedIn: 'root',
})
export class EnrollmentUpdateService {
  constructor(
    private mixpanelService: MixpanelService,
    private enrollmentsService: EnrollmentsService,
    private notificationService: NotificationService,
  ) {}

  updateEnrollment(enrollmentInfo: {
    enrollment: IEnrollment;
    activate: boolean;
    forceValidation?: boolean;
    successMessage?: string;
  }): Observable<IEnrollment> {
    const { enrollment, activate, forceValidation, successMessage } =
      enrollmentInfo;
    return this.enrollmentsService
      .updateEnrollment(enrollment, activate, !!forceValidation)
      .pipe(
        tap((updatedEnrollment) => {
          this.trackSuccess(updatedEnrollment);
          if (successMessage) {
            this.displayUpdateSuccessMessage(
              enrollment.carrier_name,
              successMessage,
            );
          }
        }),
        catchError((error: HttpErrorResponse) => {
          this.trackError(enrollment);
          if (successMessage) {
            this.displayUpdateErrorMessage();
          }

          return throwError(error);
        }),
      );
  }

  displayUpdateSuccessMessage(
    carrierName: string,
    successMessage: string,
  ): void {
    this.notificationService.success(`Your ${carrierName} ${successMessage}`, {
      horizontalPosition: 'center',
    });
  }

  private trackSuccess(enrollment: IEnrollment): void {
    this.mixpanelService.track(MixpanelEventType.APPOINTMENT_REQUEST, {
      carrier: enrollment.carrier_subdomain,
      active: enrollment.active,
      appointment_type: enrollment.appointment_type || '',
    });
  }

  private trackError(enrollment: IEnrollment): void {
    this.mixpanelService.track(MixpanelEventType.APPOINTMENT_REQUEST, {
      carrier: enrollment.carrier_subdomain,
      active: enrollment.active,
      appointment_type: enrollment.appointment_type || '',
      error: Messages.STATUS_UPDATE_ERROR,
    });
  }

  private displayUpdateErrorMessage(): void {
    this.notificationService.error(Messages.STATUS_UPDATE_ERROR, {
      horizontalPosition: 'center',
    });
  }
}
